import graphql from "babel-plugin-relay/macro";
import { PreloadedQuery, usePreloadedQuery } from "react-relay";

import { Text } from "@whoosh/design-system/src/components/primitive";
import { useGetClubCurrency } from "@whoosh/features/src/ClubCurrency";
import { ConvertCentsToDollars } from "@whoosh/utilities/src/Currency";

import { LessonPriceQuery } from "./__generated__/LessonPriceQuery.graphql";

type LessonPriceProps = {
  queryRef: PreloadedQuery<LessonPriceQuery>;
  roundsCount: number;
};

export const LessonPrice = ({ queryRef, roundsCount }: LessonPriceProps) => {
  const data = usePreloadedQuery(LessonPriceQueryString, queryRef);

  const lessonPricesTotal =
    data?.node?.bookingRounds?.edges?.reduce(
      (sum, edge) =>
        sum +
        (edge?.node?.roundRate?.rate?.__typename === "LessonRate"
          ? edge.node.roundRate.rate.totalDurationPrice ?? 0
          : 0),
      0
    ) ?? 0;

  const { currencySymbol } = useGetClubCurrency();

  return (
    <Text variant="mainBaseMedium">{`${currencySymbol}${ConvertCentsToDollars(
      lessonPricesTotal * roundsCount
    )}`}</Text>
  );
};

export const LessonPriceQueryString = graphql`
  query LessonPriceQuery($bookingId: ID!, $duration: Int, $groupSize: Int) {
    node(id: $bookingId) {
      ... on LessonBooking {
        bookingRounds: rounds {
          edges {
            node {
              roundRate {
                rate {
                  __typename
                  ... on LessonRate {
                    totalDurationPrice(
                      duration: $duration
                      playerCount: $groupSize
                    )
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
